import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AlertFlashDataService } from './alert-flash-data.service';
import { ALERT_FLASH_NAME } from './alert-flash-name';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'adminui-alert-flash',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-flash.component.html'
})
export class AlertFlashComponent implements OnInit, OnDestroy {

  @Input({ alias: 'alertFlashName', required: true }) alertFlashName: string = '';

  alertClass: string = '';
  iconClass: string = '';
  text: string = '';
  alertPrefix = 'toast-';
  iconPrefix = 'vismaicon-'
  show = false;

  alertFlashNameConst = ALERT_FLASH_NAME;
  private destroy$ = new Subject<void>();

  constructor(private readonly alertFlashDataService: AlertFlashDataService, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.changeDetectorRef.detach();
    
    this.alertFlashDataService.alertMessage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(alertFlashMessage => {
      if (alertFlashMessage.alertFlashName === this.alertFlashName) {
        if (alertFlashMessage.type !== '' && alertFlashMessage.text !== '') {
          this.alertClass = `toast-${alertFlashMessage.type}`;
          this.iconClass = `vismaicon-${alertFlashMessage.type}`;
          this.text = alertFlashMessage.text;
          this.show = true;
          this.changeDetectorRef.detectChanges();
        } else {
          this.show = false;
          this.changeDetectorRef.detectChanges();
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    this.show = false;
    this.alertFlashDataService.reset();
  }
}
